import React, {useState, useEffect} from "react";
import { sendStudentUpdatePickupLocationRequest } from "../../Actions/CourseA";
import LocationPopupImage from "./Assets/LocationPopup.png";
import { useDispatch, useSelector } from 'react-redux';

const UpdatePickupLocationPopup = ({setUpdatePickupLocationPopup, enrolledCourseTimeTable,
    UserId, EnrollmentId, studentAddress }) => {
  const Border = "border-[#E2E2E2] border-[1px] border-solid";
  const Dispatch = useDispatch()

  // State to store selected class and address
  const [selectedClass, setSelectedClass] = useState("");
  const [updatedAddress, setUpdatedAddress] = useState("");

  // Get today's date
  const today = new Date();

  // Filter and sort classes to find the next upcoming class
  const upcomingClasses = enrolledCourseTimeTable?.timetable
      .map(event => ({
          ...event,
          startDate: new Date(event.startDate) // Convert to Date object
      }))
      .filter(event => event.startDate > today) // Get only future classes
      .sort((a, b) => a.startDate - b.startDate); // Sort by date

  // Get the next class
  const nextClass = upcomingClasses.length > 0 ? upcomingClasses[0] : null;

  const closePopup = () =>{
      console.log("Close icon clicked");
      setUpdatePickupLocationPopup(false);
  }

  const handleSendRequest = (action) => {
    Dispatch(sendStudentUpdatePickupLocationRequest(UserId, EnrollmentId, studentAddress, updatedAddress))
    .then(() => {
       // Set a timeout to refresh the page after 5 seconds
       setTimeout(() => {
            window.location.reload();
       }, 5000);

    })
};

    return (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[23px] bg-gradient-to-r from-white to-[#D6D8FF] p-[20px] shadow-lg w-[400px]">
            <div className="absolute top-2 right-2">
                <img
                    className="absolute right-3 top-[4px] cursor-pointer"
                    src={require("./Assets/Cross.svg").default}
                    alt=""
                    onClick={closePopup}
                />
            </div>

            <div className="w-full flex flex-col gap-[10px] justify-center items-center">
                <p className="text-[18px] text-center text-[#000000] font-bold">Update Pickup Location</p>
                <img src={LocationPopupImage} alt="LocationPopupImage" />
                {/* Dropdown for selecting class */}
                <select
                    className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029]`}
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.target.value)}
                >
                    <option value="">Select Class</option>
                    {nextClass && (
                        <option value={nextClass.EventId}>
                            {nextClass.startDate.toLocaleDateString()} - {nextClass.startDate.toLocaleTimeString()}
                        </option>
                    )}
                    <option value="all">For All Upcoming Classes</option>
                </select>

                {/* Input for address */}
                <input
                    type="text"
                    id="updatedAddress"
                    name="updatedAddress"
                    placeholder="1225 Kennedy Rd, Suite 2000, Toronto, M1P 4Y1, ON, Canada."
                    className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029]`}
                    value={updatedAddress}
                    onChange={(e) => setUpdatedAddress(e.target.value)}
                />

                <p className="text-[16px] text-center text-[#000000] w-[300px]">Are you sure! You want to change the pickup Location for this class?</p>
                <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] '>
                        <button className='w-[150px] h-[35px] text-[14px] lg:text-[14px] text-center text-[#4C34AD] rounded-[10px] font-bold cursor-pointer'
                        style={{
                            border: '1px solid #4C34AD'
                        }}
                        onClick={closePopup}
                    >
                            Cancel
                        </button>

                        <button
                        className={`w-[150px] h-[35px] text-[14px] lg:text-[14px] text-center rounded-[10px] text-[#FFFFFF] font-bold ${
                            selectedClass && updatedAddress ? "bg-[#4C34AD] cursor-pointer" : "bg-[#D7DAE2] cursor-not-allowed"
                        }`}
                        onClick={handleSendRequest}
                        disabled={!selectedClass || !updatedAddress} // Disable if either is empty
                        >
                        Send Request
                        </button>
                </div>
                <p className="text-[14px] text-center text-[#000000] w-[300px]">Your request pickup location will be updated once the staff approves your request.</p>
            </div>
        </div>
        </div>
    );
  };

export default UpdatePickupLocationPopup;
